import React from 'react';
import { useAppSelector } from 'src/hooks';
import { Typography, Box, Grid, List, ListItem, LinearProgress } from '@mui/material';

export default function FeaturesMap() {
  const { isProductFeatureLoading, productFeatureList } = useAppSelector((state) => state.landing);

  return (
    <Box
      sx={{
        width: '100%',
        marginTop: '5px',
        minHeight: '300px',
        maxHeight: '350px',
        overflowY: 'auto',
        padding: '12px',
        boxSizing: 'border-box',
      }}
    >
      {isProductFeatureLoading ? (
        <div style={{ padding: '10px 0px' }}>
          <LinearProgress />
        </div>
      ) : productFeatureList?.release_notes_data? (
      <List>
        {Object.values(productFeatureList.release_notes_data).map((notes: any, versionIndex: number) =>
          notes.map((note: any, noteIndex: number) =>
            note.details.map((feature: any, featureIndex: number) => (
              <ListItem key={`${versionIndex}-${noteIndex}-${featureIndex}`}>
                <Grid container spacing={2} alignItems="center">
                  {/* Title */}
                  <Grid item md={4}>
                    <Typography
                      variant="h6"
                      color={feature.market_available ? '#3A3A3A' : '#ACACAC'}
                    >
                      {feature.title}
                    </Typography>
                  </Grid>
                  {/* Description */}
                  <Grid item md={8}>
                    <Typography
                      variant="body2"
                      color={feature.market_available ? '#0000A09C' : '#ACACAC'}
                    >
                      {feature.description.join(' ')}
                    </Typography>
                  </Grid>
                </Grid>
              </ListItem>
            ))
          )
        )}
      </List>)
      :(
        <div>No data found</div>
      )}
    </Box>
  );
}
